import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import type { PeriodSummaryMode } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryMode.ts";
import DropDownMenu from "@/shared/components/generic/dropdown-menu/DropDownMenu";
import "./PeriodEventsDropdown.scss";
import { usePeriodEventsDropdownController } from "@/pages/human-resources/time-management/schedules/site-schedule/analysis/period-summary/usePeriodEventsDropdownController.ts";
import IconChevronDownProper from "@/shared/components/generic/icons/IconChevronDownProper.tsx";
import IconCalendarStar from "@/shared/components/generic/icons/IconCalendarStar.tsx";
import type { PeriodSummaryRange } from "@/pages/human-resources/time-management/business/analysis/PeriodSummaryRange.ts";

interface Props {
  siteId: string;
  date: Date;
  mode: PeriodSummaryMode;
  range: PeriodSummaryRange;
}

export default function PeriodEventsDropdown({
  siteId,
  date,
  mode,
  range,
}: Props): ReactElement {
  const { t } = useTranslation("humanResources");
  const { count, open, anchorEl, handleOpen, handleClose, menuItemProps } =
    usePeriodEventsDropdownController(siteId, date, mode, range);

  return (
    <div className="day-events">
      <button
        type="button"
        className="events-button"
        onClick={handleOpen}
        aria-controls="day-events-menu"
        disabled={count === 0}
      >
        <IconCalendarStar className="calendar-icon" />
        <span className="text">{t("timeManagement.analysis.events")}</span>
        <span className="count">({count})</span>
        <span className="chevron" aria-hidden>
          {count > 0 && <IconChevronDownProper className="chevron-icon" />}
        </span>
      </button>
      <DropDownMenu
        open={open}
        anchorEl={anchorEl}
        handleClose={handleClose}
        menuItemProps={menuItemProps}
        horizontalAnchorOrigin="left"
        paperClassName="day-events-menu-paper"
        listClassName="day-events-menu-list"
      />
    </div>
  );
}
